module.exports = __webpack_public_path__ + "static/img/icon.251cc16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_0/icon.jpg
// module id = atZ5
// module chunks = 0